import { HEADER_COLOR, TEXT_COLOR } from '@/styles';
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

const paragraphStyles = css`
  color: ${TEXT_COLOR};
  font-size: 15px;
  font-weight: 400;
  line-height: 1.6;
`;

const passwordCheckboxOverrides = css`
  color: ${HEADER_COLOR};
  font-size: 15px;
  margin-bottom: 9px;
`;

type ToolTypeStyleProps = {
  arrowRightPosition: number | undefined;
  tooltipMarginTop: number | undefined;
  isDisplayTooltip: boolean;
};

const getTooltipStyleOverrides = (
  props: ToolTypeStyleProps,
): SerializedStyles => css`
  margin: 0;
  margin-top: ${props.tooltipMarginTop}px;
  max-width: unset;
  padding: 0;
  right: 0;
  visibility: ${props.isDisplayTooltip ? 'visible' : 'hidden'};

  &::after {
    right: ${props.arrowRightPosition}px;
  }
`;

export { getTooltipStyleOverrides, paragraphStyles, passwordCheckboxOverrides };
